import { Dropdown, Button, Input } from "antd";
import { BsPlus } from "react-icons/bs";
import { HiMiniMinusSmall } from "react-icons/hi2";
import React, { useState } from "react";
import { capitalizeWords, titleCase } from "@/ts/utils";

interface IDropdownItem {
  title: string;
  subtitle?: string;
  metric?: string;
  metricValue?: string;
  value: string;
}

interface IRevstackTrendsSelectDropDownProps {
  dropdownItems?: IDropdownItem[];
  addPillsBtnTitle?: string;
  selectedPills?: any[];
  setSelectedPills?: (pills: any[]) => void;
  onAddPills?: (value: any) => void;
  onRemovePills?: (value: any) => void;
  disableDropDown?: boolean;
  maxAllowedPills?: number;
  dropdownFilterPlaceHolder?: string;
}

const CustomDropdownMenu = ({ items, selectedPills, onAddPills, onRemovePills, maxAllowedPills, dropdownFilterPlaceHolder }:
  {
    items: IDropdownItem[],
    selectedPills?: any[],
    onAddPills?: (value: any) => void,
    onRemovePills?: (value: any) => void,
    maxAllowedPills?: number,
    dropdownFilterPlaceHolder?: string
  }) => {

  const [search, setSearch] = useState("");

  const filteredItems = items.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const isItemSelected = (item: IDropdownItem) => {
    return selectedPills?.some(pill => pill.value === item?.value) || false;
  };

  return (
    <div style={{ width: 300 }} className="revstack-trends-chart-pill-dropdown-container">
      <div className="revstack-trends-chart-pill-dropdown-search-container">
        <Input.Search
          placeholder={dropdownFilterPlaceHolder || "Search Sub Categories"}
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="revstack-trends-chart-pill-dropdown-search"
        />
      </div>

      <div style={{ maxHeight: 300, overflowY: "auto", overflowX: "hidden" }}>
        {filteredItems.map(item => (
          <div
            className={`revstack-trends-chart-pill-dropdown-item ${selectedPills?.length >= (maxAllowedPills ?? 5) && !isItemSelected(item) ? "pe-none opacity-50" : ""}`}
            style={{cursor: "pointer"}}
            onClick={()=>{
              if(isItemSelected(item)){
                onRemovePills(item.title);
              }else{
                onAddPills(item.title);
              }
            }}
            key={item.value}
          >
            <div className="revstack-trends-chart-pill-dropdown-item-content">
              <div>
                <div className={`item-title ${isItemSelected(item) ? "selected" : ""}`} style={{ fontWeight: 600 }}>{capitalizeWords(item.title)}</div>
                <div className="revstack-trends-chart-pill-dropdown-item-subtitle" style={{ fontSize: 12, color: "#888" }}>
                  {item?.subtitle ? `${capitalizeWords(item?.subtitle)} • ` : ""} {item?.metric}: {item?.metricValue}
                </div>
              </div>
              <Button
                type="text"
                icon={isItemSelected(item) ? <HiMiniMinusSmall className="icon" /> : <BsPlus className="icon" />}
                size="small"
                onClick={() => {
                  if (isItemSelected(item)) {
                    onRemovePills(item.title);
                  } else {
                    if (selectedPills?.length <= (maxAllowedPills ?? 5) - 1) {
                      onAddPills(item.title);
                    }
                  }
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const RevstackTrendsSelectDropDown: React.FC<IRevstackTrendsSelectDropDownProps> = ({
  dropdownItems = [],
  addPillsBtnTitle = "Add Subcategories",
  selectedPills = [],
  setSelectedPills = () => { },
  onAddPills = () => { },
  onRemovePills = () => { },
  disableDropDown = false,
  maxAllowedPills = 5,
  dropdownFilterPlaceHolder = "Search Sub Categories"
}) => (
  <Dropdown
    overlay={<CustomDropdownMenu items={dropdownItems.length > 0 ? dropdownItems : []}
      selectedPills={selectedPills}
      onAddPills={onAddPills}
      onRemovePills={onRemovePills}
      maxAllowedPills={maxAllowedPills}
      dropdownFilterPlaceHolder={dropdownFilterPlaceHolder}
    />}
    trigger={["click"]}
    placement="bottomLeft"
    overlayClassName="revstack-trends-dropdown-overlay"
    overlayStyle={{ zIndex: 2147483647 }}
    getPopupContainer={() => document.body}
  >
    <Button disabled={disableDropDown}>+ {addPillsBtnTitle}</Button>
  </Dropdown>
);

export default RevstackTrendsSelectDropDown;